var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { faBiking } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

var FaIcon = function FaIcon(_ref) {
    var icon = _ref.icon,
        size = _ref.size,
        className = _ref.className,
        rest = _objectWithoutProperties(_ref, ['icon', 'size', 'className']);

    return React.createElement(FontAwesomeIcon, _extends({ icon: icon, size: size, className: className }, rest));
};

FaIcon.defaultProps = {
    icon: faBiking,
    size: "sm" // xs, sm, lg, 1_3x, 2x, 3x,.....9x, 10x

};
FaIcon.propTypes = process.env.NODE_ENV !== "production" ? {
    /*
    * fontawesome icon name
    */
    icon: PropTypes.node.isRequired,
    size: PropTypes.oneOf(['xs', 'sm', 'lg', "1_3x", '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
    className: PropTypes.string

} : {};
export default FaIcon;